import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum DefectSecurityRight {
    CanAccess = 17000,
    Manage = 17001,
}

export class DefectSecurityModule extends BaseSecurityModule<DefectSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Defects,
            [
                { _id: DefectSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: DefectSecurityRight.Manage, name: 'Manage', basic: true },
            ] as SecurityRight<DefectSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}
